import { createSlice } from '@reduxjs/toolkit';

const initialState = {     //Reducer'a başlangıç değerleri olarak null atadım 
  ac_auth_token: null,
  refreshToken: null,
  isSessionExtended: false,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setTokens: (state, action) => {
      const { ac_auth_token, refreshToken } = action.payload;
      console.log('****AuthToken****:', ac_auth_token);
      console.log("***Refresh token****", refreshToken)
      
      state.ac_auth_token = ac_auth_token;
      state.refreshToken = refreshToken;
      state.isSessionExtended = false;
    },
    setSessionExtended: (state, action) => {
      state.isSessionExtended = action.payload;
    },
  },
});

export const { setTokens, setSessionExtended } = sessionSlice.actions;
export default sessionSlice.reducer;
 

//Bu dosya ile createSlice kullanarak bir slice oluşturuyoruz.iki adet action creator var bunlar 1- setTokens 2-setSessionExtended
//setTokens yeni accesstoken ve refreshtoken bilgilerini alara stateyi günceller.
//setSessionExtended oturumun uzatılıp uzatılmadığını belirten durumu günceller